React           = require 'react'
MessageBusMixin = require '../mixins/message_bus'

module.exports = DeviceHeight = React.createClass
  mixins: [ MessageBusMixin ]
  eventDefault: ->
    @publish 'deviceHeight', false

  eventStretch: ->
    @publish 'deviceHeight', true

  render: ->
    React.createElement("div", {"className": "button-toolbar"},
      React.createElement("div", {"className": "button-toolbar__title"}, "Device height"),
      React.createElement("div", {"className": "button-group"},
        React.createElement("button", {"className": "button button--medium button--secondary button-group__button", "onClick": (@eventDefault)}, "Default"),
        React.createElement("button", {"className": "button button--medium button--secondary button-group__button", "onClick": (@eventStretch)}, "Stretch")
      )
    )



// WEBPACK FOOTER //
// ./~/cjsx-loader!./app/js/components/device_height.cjsx